import { render, staticRenderFns } from "./pre-banner-text-card.vue?vue&type=template&id=18f7948e&scoped=true"
import script from "./pre-banner-text-card.vue?vue&type=script&lang=js"
export * from "./pre-banner-text-card.vue?vue&type=script&lang=js"
import style0 from "./pre-banner-text-card.vue?vue&type=style&index=0&id=18f7948e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f7948e",
  null
  
)

export default component.exports